// extracted by mini-css-extract-plugin
export default {"paneCloseLinkArrow":"paneCloseLinkArrow---IJa6N","paneCloseLinkX":"paneCloseLinkX---Dbo3u","paneCloseLink":"paneCloseLink---xHSIz"};